// @flow
import { makeApiCall } from '../../../../services/apiService/apiService';
import tabViewList from '../../../commons/tabView/tabViewHelper';

export const oaManagerActions = {
  GET_ALL_DATA: 'GET_ALL_DATA',
  FILTER_TABLE_DATA: 'FILTER_TABLE_DATA'
};

export const filterTableData = (val: string) => ({
  type: oaManagerActions.FILTER_TABLE_DATA,
  payload: val
});

export const getAllDataAction = (obj: Object) => ({
  type: oaManagerActions.GET_ALL_DATA,
  payload: obj
});

export const getAllData = () => (dispatch: Function) => {
  dispatch(
    getAllDataAction({
      isLoading: true,
      isLoaded: false,
      tableData: [],
      tableDataFiltered: []
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'oaGetCreate',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        const data = {
          isLoading: false,
          isLoaded: true,
          tableData: res.payload,
          tableDataFiltered: res.payload,
          tabViewList: tabViewList.OA_MANAGER
        };
        data.tabViewList[0].name = `OA (${data.tableData.length})`;
        dispatch(getAllDataAction(data));
      } else if (res.status === 'FAILURE') {
        dispatch(
          getAllDataAction({
            isLoading: false,
            isLoaded: true,
            tableData: [],
            tableDataFiltered: []
          })
        );
      }
    },
    failureCb: () => {
      dispatch(
        getAllDataAction({
          isLoading: false,
          isLoaded: true,
          tableData: [],
          tableDataFiltered: []
        })
      );
    },
    catchCb: () => {
      dispatch(
        getAllDataAction({
          isLoading: false,
          isLoaded: true,
          tableData: [],
          tableDataFiltered: []
        })
      );
    }
  };

  return makeApiCall(requestObj);
};
